/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-warning-banner',
  templateUrl: './warning-banner.component.html',
  styleUrls: ['./warning-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarningBannerComponent {
  @Input() errorMessage: string | null = null;

  constructor() {}
}
